import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["children", "className", "spacingTop"],
  _excluded2 = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as l } from "react/jsx-runtime";
import { c as r } from "./clsx-OuTLNxxd.js";
import { useState as m, useEffect as d, startTransition as u, useRef as T } from "react";
import { TabList as p, TabPanel as L, Tabs as y } from "react-tabs";
function S(s, a) {
  const [i, n] = m(!1);
  return d(() => {
    function e() {
      if (!s.current) return;
      const c = Math.floor(s.current.getBoundingClientRect().top),
        b = Math.ceil(parseInt(getComputedStyle(s.current).top) + (a || 0)),
        o = c <= b;
      o && !i ? u(() => n(!0)) : !o && i && u(() => n(!1));
    }
    return e(), document.addEventListener("scroll", e), window.addEventListener("resize", e), window.addEventListener("orientationchange", e), () => {
      document.removeEventListener("scroll", e), window.removeEventListener("resize", e), window.removeEventListener("orientationchange", e);
    };
  }, [a, i, s]), i;
}
const k = "Tabs-module_tabs__vvfKj",
  f = "Tabs-module_tab-list__kxXeX",
  P = "Tabs-module_tab-list-container__MKCRl",
  g = "Tabs-module_mobile-sticky__PdPyS",
  h = "Tabs-module_all-breakpoints-sticky__Y7uzm",
  v = "Tabs-module_list-is-sticky__hCHPy",
  w = "Tabs-module_spacing-top__QwS-V",
  N = "Tabs-module_tab-list-neutral05__4I6KT",
  C = "Tabs-module_tab-list-white__M-qIC",
  E = "Tabs-module_tab-list-destination-light__XyPRk",
  I = "Tabs-module_tab-panel__jQRjU",
  R = "Tabs-module_tab-panel-selected__UyeLH",
  j = "Tabs-module_tab-panel-spacing-top__hHKeF",
  t = {
    tabs: k,
    tabList: f,
    tabListContainer: P,
    mobileSticky: g,
    allBreakpointsSticky: h,
    listIsSticky: v,
    spacingTop: w,
    tabListNeutral05: N,
    tabListWhite: C,
    tabListDestinationLight: E,
    tabPanel: I,
    tabPanelSelected: R,
    tabPanelSpacingTop: j
  },
  x = _ref => {
    let {
      children: s,
      className: a,
      wrapperClassName: i,
      spacingTop: n = !1,
      backgroundColor: e = "neutral05",
      mobileSticky: c,
      allBreakpointsSticky: b
    } = _ref;
    const o = T(null),
      _ = S(o);
    return /* @__PURE__ */l("div", {
      ref: o,
      className: r(i, t.tabListContainer, {
        [t.tabListNeutral05]: e == "neutral05",
        [t.tabListWhite]: e == "white",
        [t.tabListDestinationLight]: e == "destinationLight",
        [t.spacingTop]: n,
        [t.mobileSticky]: c,
        [t.allBreakpointsSticky]: b,
        [t.listIsSticky]: _
      }),
      children: /* @__PURE__ */l(p, {
        className: r(t.tabList, a),
        children: s
      })
    });
  };
x.tabsRole = "TabList";
const B = _ref2 => {
  let {
      children: s,
      className: a,
      spacingTop: i
    } = _ref2,
    n = _objectWithoutProperties(_ref2, _excluded);
  return /* @__PURE__ */l(L, _objectSpread(_objectSpread({
    className: r(t.tabPanel, a, {
      [t.tabPanelSpacingTop]: i
    }),
    selectedClassName: t.tabPanelSelected
  }, n), {}, {
    children: s
  }));
};
B.tabsRole = "TabPanel";
const H = _ref3 => {
  let {
      children: s
    } = _ref3,
    a = _objectWithoutProperties(_ref3, _excluded2);
  return /* @__PURE__ */l(y, _objectSpread(_objectSpread({
    className: t.tabs
  }, a), {}, {
    children: s
  }));
};
export { x as T, B as a, H as b, S as u };